// extracted by mini-css-extract-plugin
export default {"slideShowControlWrapper":"hVXbSvbakw8iyELjiELm"};